
export const fatorArredondamentoFields = [
    {
        key: "calculoFatorJuros",
        label: "Cálculo Fator Juros",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "ARREDONDAR"
    },
    { key: "casasFatorJuros", label: "Casas Fator Juros", type: "number", maskType: "integer", md: 4, xs: 12, breakAfter: true, defaultValue: 9 },
    {
        key: "calculoJuros",
        label: "Cálculo Juros",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "TRUNCAR"
    },
    { key: "casasJuros", label: "Casas Juros", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 8 },
    {
        key: "calculoFatorCorrecao",
        label: "Cálculo Fator Correção",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "TRUNCAR"
    },
    { key: "casasFatorCorrecao", label: "Casas Fator Correção", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 8 },
    {
        key: "calculoCorrecao",
        label: "Cálculo Correção",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "TRUNCAR"
    },
    { key: "casasCorrecao", label: "Casas Correção", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 8 },
    {
        key: "calculoFatorJurosCDI",
        label: "Cálculo Fator Juros CDI",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "ARREDONDAR"
    },
    { key: "casasFatorJurosCDI", label: "Casas Fator Juros CDI", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 9 },
    {
        key: "calculoVNA",
        label: "Cálculo VNA",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "TRUNCAR"
    },
    { key: "casasVNA", label: "Casas VNA", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 8 },
    {
        key: "calculoFatorDesconto",
        label: "Cálculo Fator Desconto",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "ARREDONDAR"
    },
    { key: "casasFatorDesconto", label: "Casas Fator Desconto", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 9 },
    {
        key: "calculoFatorExpectativa",
        label: "Cálculo Fator Expectativa",
        required: true,
        md: 4,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        xs: 12,
        sx: { maxWidth: "100%" },
        defaultValue: "ARREDONDAR"
    },
    { key: "casasFatorExpectativa", label: "Casas Fator Expectativa", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 9 },
    {
        key: "calculoPU",
        label: "Cálculo PU",
        required: true,
        type: "select",
        options: [
            { value: "TRUNCAR", label: "TRUNCAR" },
            { value: "ARREDONDAR", label: "ARREDONDAR" }],
        sx: { maxWidth: "100%" },
        defaultValue: "ARREDONDAR"
    },
    { key: "casasPU", label: "Casas PU", type: "number", maskType: "integer",md: 4, xs: 12, breakAfter: true, defaultValue: 6 },
]